import { combineReducers } from 'redux';
import guide from './guide';

const preDelivery = combineReducers({
	guide,
});

export default preDelivery;
